/*
 * @Author: 张斌
 * @Date: 2023-10-25 14:57:51
 * @LastEditors: 张斌
 * @LastEditTime: 2024-01-04 10:57:44
 */
import { Vue, Component } from 'vue-property-decorator'
import { ElLoadingComponent, LoadingServiceOptions } from 'element-ui/types/loading'
import { UserModule } from '@/store/modules/user'
import { IPower } from '@/model/userState'
import Jsencrypt from 'jsencrypt'

@Component
export default class BaseClass extends Vue {
  private _loadingInstance: ElLoadingComponent | undefined = undefined
  /** 用户信息 */
  protected get userInfo() {
    return UserModule.userInfo
  }
  /** 说明文档 */
  protected get userDoc() {
    return UserModule.userDoc
  }
  /** 公司信息 */
  protected get orgInfo() {
    return UserModule.orgInfo
  }
  /** roleId 映射对应角色名称 */
  protected getPowerMap(role: number) {
    const findResult = UserModule.powerList.find(_ => Number(_.id) === Number(role)) || {} as IPower
    return findResult.name || ''
  }
  /** posId 映射对应管理区域 */
  protected getPosMap(posId: string[]) {
    // console.log(posId);
    
    const result = posId.map((pos: string) => {
      const posArr = pos.split('#') || []
      let names: string = ''
      let list: any[] = UserModule.orgPosList
      // console.log(JSON.stringify(list));
      
      let i = 0
      while (i < posArr.length) {
        let posItem = list.find((item) => String(item.id) === String(posArr[i])) || {}
        if (posItem.children) {
          list = posItem.children
        }
        names += ' ' + (posItem.name || '')
        i++
      }
      return names
    })
    return result.join(' / ')
  }
  /** deptId 映射对应用户部门 */
  protected getDeptMap(deptId: number[]) {
    const filterResult = UserModule.orgDeptList.filter(_ => deptId.includes(_.id))
    return filterResult
  }
  /** 加密数据 */
  protected useEncryption(data: any) {
    let jse = new Jsencrypt()
    jse.setPublicKey(UserModule.pubkey)
    return jse.encrypt(data)
  }
  /**
   * 显示Loading
   * @param options
   */
  protected showLoading(options: LoadingServiceOptions = { body: true, fullscreen: true, lock: true, target: '.app-main' }): ElLoadingComponent {
    if (this._loadingInstance) return this._loadingInstance
    this._loadingInstance = this.$loading(options)
    return this._loadingInstance
  }

  protected closeLoading() {
    if (this._loadingInstance) {
      this._loadingInstance.close()
      this._loadingInstance = undefined
    }
  }
}
